import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronDown, faSearch, faTh, faTimes, faUsers } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faChevronDown, faFacebookF, faSearch, faTwitter, faTh, faTimes, faUsers)

Vue.component('font-awesome-icon', FontAwesomeIcon)
